var $ = require('jQuery');
var Dialog = require('../dialog.js');

/**
 * Deletism Class
 *
 * Note: Since delete is a common action, this class is generic and loads the submission URL and METHOD from
 *  the button directly to aid re-use.
 *  For custom single-use Markers, this information can be defined directly in the class.
 */
module.exports = function(marker) {
    var parent = this;

    // Handle Delete button click.
    var deleteClicked = function() {
        var form = $("#marker-action-delete");

        marker.addIdsToForm(form);
        form.submit();
    };

    // jQuery Bindings
    $("#marker-action-delete .marker-action-button").on("click", function() {
        if(!marker.idsExist()) {
            marker.displayError();
            return;
        }

        var phrase = marker.count() == 1 ?
            $('#lang-strings #alerts-delete-item').text() :
            $('#lang-strings #alerts-delete-items').text();

        var dialog = new Dialog();

        dialog.show({ content: phrase }, function() {
            deleteClicked();
        });
    });
};
